import { useState, useEffect } from 'react';

function getStorageValue<T>(key: string, defaultValue: T) {
  const saved = localStorage.getItem(key);
  const initial = saved !== null ? JSON.parse(saved) : defaultValue;
  return initial;
}

export const useLocalStorage = <T>(key: string, defaultValue: T) => {
  const state = useState<T>(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state[0]));
  }, [key, state[0]]);

  return state;
};
